
import { Options, Vue } from "vue-class-component";
import { useStore } from "../store";
import { MutationTypes } from "../store/mutation-types";
import { sortByFilter } from "../data/functions";
// @ts-ignore
import guests from "../data/guestData.js";

@Options({
  methods: {
    activeLetter(number: number, filter: string, menu: number) {
      const data = { number: number, filter: filter, menu: menu };
      return this.$store.commit(MutationTypes.SET_DAY_MENU, data);
    },
    // sets active css on chosen letter
    selectLetter(letter: string) {
      return this.$store.state.activeDayMenu.filter === letter
        ? "alphabet-square-active"
        : "alphabet-square";
    },
    lettersDisplay() {
      const regex = new RegExp(/[a-zà-ÿ]/);
      const guestFirstLetters = new Set(
        this.guests
          .map((guest: any) => guest.name[0].toLowerCase())
          .filter((letter: string) => regex.test(letter))
          .flat()
      );
      const array: any = Array.from(guestFirstLetters).sort();
      array.map((letter: any) =>
        letter.normalize("NFD").replace(/[\u0300-\u036f]/, "")
      );
      const parsed = array
        .map((letter: any) =>
          letter.normalize("NFD").replace(/[\u0300-\u036f]/, "")
        )
        .sort((a: any, b: any) => a.localeCompare(b));
      parsed.push("#");
      return parsed;
    },
  },
})
export default class AlphabetMenu extends Vue {
  store = useStore();
  sortByFilter = sortByFilter;
  guests = guests;
}
